import { BillingHistoryItemArray } from './billing.history.item';

export interface IBillingHistoryResponse {

    DateTimeCreated: Date;
    DateTimePaid: Date;
    Total: number;
    TotalPaid: number;
    InvoiceNumber: string;
    Items: BillingHistoryItemArray;
    Refunded: boolean;
    IsOnHoldInvoice: boolean;
    // FixDates();

}

export class BillingHistoryResponse implements IBillingHistoryResponse {

    DateTimeCreated: Date;
    DateTimePaid: Date;
    Total: number;
    TotalPaid: number;
    InvoiceNumber: string;
    Items: BillingHistoryItemArray;
    Refunded: boolean;
    IsOnHoldInvoice: boolean;


    // FixDates() {
    //     this.DateTimeCreated = new Date(this.DateTimeCreated);
    //     this.DateTimePaid = new Date(this.DateTimePaid);
    // }
}

export class BillingHistoryResponseArray extends Array<BillingHistoryResponse> {

    constructor(...items: BillingHistoryResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, BillingHistoryResponseArray.prototype);
    }

    public InitFromJSON() {

        if (this.length == 0)
            return;

        this.forEach((item) => {
            Object.setPrototypeOf(item, BillingHistoryResponse.prototype);
            // item.FixDates();
        })
    }

}